import { Plus, ChevronDown, Calendar1, Download } from 'lucide-react'
import { BillingPackage } from '../../Packages/types/BillingPackage';

interface SubscriptionsHeaderProps {
    activeTab: string;
    setActiveTab: (tab: string) => void;
    selectedService: string;
    setSelectedService: (service: string) => void;
    packages: BillingPackage[];
    selectedPackage: string;
    setSelectedPackage: (packageName: string) => void;
    onExport: () => void;
    searchTerm: string;
    setSearchTerm: (term: string) => void;
}

export default function SubscriptionsHeader({ activeTab, setActiveTab, selectedService, setSelectedService, packages, selectedPackage, setSelectedPackage, onExport, searchTerm, setSearchTerm }: SubscriptionsHeaderProps) {

    const handleTabClick = (tab: string) => {
        setActiveTab(tab);
    };

    return (
        <div className="w-full flex flex-col items-start justify-start">
            <div className="flex items-center gap-x-6">
                <nav className="flex text-white text-xs">
                    <ul className="flex gap-x-6">
                        <li
                            className={`cursor-pointer ${activeTab === 'All' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('All')}
                        >
                            All
                        </li>
                        <li
                            className={`cursor-pointer ${activeTab === 'paid' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('paid')}
                        >
                            Paid
                        </li>
                        <li
                            className={`cursor-pointer ${activeTab === 'unpaid' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('unpaid')}
                        >
                            Unpaid
                        </li>
                        {/* <li
                            className={`cursor-pointer ${activeTab === 'active' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('active')}
                        >
                            Active
                        </li>
                        <li
                            className={`cursor-pointer ${activeTab === 'expired' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('expired')}
                        >
                            Expired
                        </li> */}
                    </ul>
                </nav>
            </div>

            <div className="w-full flex items-center justify-between my-3">
                <div className="flex items-center gap-x-2">

                    <div className="relative">
                        <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700" onChange={(e) => setSelectedService(e.target.value)}>
                            <option value="All">All Services</option>
                            <option value="kanema">Kanema Online</option>
                            <option value="mingoli">Mingoli</option>
                            <option value="katswiri">Katswiri</option>
                            <option value="nkhani">Nkhani</option>
                        </select>
                    </div>

                    <div className="relative">
                        <select
                            className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700"
                            value={selectedPackage}
                            onChange={(e) => setSelectedPackage(e.target.value)}
                        >
                            <option value="All">All Packages</option>
                            {packages.map((pkg, index) => (
                                <option key={index} value={pkg.name}>
                                    {pkg.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* <button className='w-fit flex items-center justify-center gap-x-1 bg-white rounded-md px-2 py-1 text-gray-700 text-xs'>
                        <p>Start Day</p>
                        <Calendar1 size={14} />
                        <p>End Day</p>
                        <Calendar1 size={14} />
                    </button> */}
                </div>

                <div className='flex items-center gap-x-2'>
                    <input type="text" placeholder="Search User" className="w-72 h-8 px-3 py-1 rounded-md border border-white bg-transparent text-xs text-white" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    <button className='w-fit flex items-center justify-center gap-x-1 bg-white rounded-md px-4 py-2 text-gray-700 text-xs hover:scale-105 transition-all duration-300' onClick={onExport}>
                        <Download size={14} />
                        <p>Export</p>
                    </button>
                </div>
            </div>
        </div>
    )
}

function setActiveTab(tab: string) {
    throw new Error('Function not implemented.');
}
